import React from 'react'
import MetaTags from '../components/MetaTags'
import ContactForm from '../components/ContactForm'

export default function Contact() {
  return (
    <div>
      <MetaTags
        title="Kontakt - Elses skrub og skur"
        description="Kontakt Elses skrub og skur i Skjern. Ring til mig på 52 50 67 94 eller send en e-mail for en uforpligtende snak om rengøring."
      />

      {/* Hero Header */}
      <section className="bg-[#FAF9F5] py-12 lg:py-16 border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] bg-[#EEF4F0] px-3.5 py-1.5 rounded-full inline-block border border-[#D2E0D6]">
              Kontakt mig
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif-display font-bold text-[#285F41] tracking-tight">
              Jeg står klar til at hjælpe dig
            </h1>
            <p className="text-base sm:text-lg text-[#4A5D50] leading-relaxed">
              Har du spørgsmål til min rengøringsservice eller ønsker du en uforpligtende snak om privat- eller erhvervsrengøring i Skjern? Kontakt mig direkte eller benyt formularen herunder.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Grid */}
      <section className="py-16 bg-[#FAF9F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Contact Details Column */}
            <div className="lg:col-span-5 space-y-8">
              
              <div className="bg-white p-8 rounded-2xl border border-[#D9E3DC] shadow-sm space-y-6">
                <div className="border-b border-[#E2E7E2] pb-4">
                  <div className="brand-wordmark text-2xl font-bold text-[#285F41]">
                    Elses skrub og skur
                  </div>
                  <p className="text-xs text-[#516859] mt-0.5">
                    Rengøring i Skjern &amp; omegn
                  </p>
                </div>

                <div className="space-y-5 text-sm">
                  
                  {/* Adresse */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-regular fa-location-dot" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] block mb-0.5">
                        Adresse
                      </span>
                      <p className="font-semibold text-[#285F41]">Vardevej 58</p>
                      <p className="text-[#4A5D50]">6900 Skjern</p>
                    </div>
                  </div>

                  {/* Telefon */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-regular fa-phone" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] block mb-0.5">
                        Telefon
                      </span>
                      <a
                        href="tel:52506794"
                        className="contact-no-break font-bold text-[#285F41] text-base hover:text-[#357753] transition-colors"
                      >
                        52 50 67 94
                      </a>
                      <p className="text-xs text-[#516859] mt-0.5">Ring for direkte kontakt</p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-regular fa-envelope" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] block mb-0.5">
                        E-mail
                      </span>
                      <a
                        href="mailto:else_christiansen@godmail.dk"
                        className="contact-no-break font-semibold text-[#285F41] hover:text-[#357753] transition-colors"
                      >
                        else_christiansen@godmail.dk
                      </a>
                    </div>
                  </div>

                  {/* CVR */}
                  <div className="flex items-start gap-4 pt-2 border-t border-[#E2E7E2]">
                    <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg shrink-0">
                      <i className="fa-regular fa-id-card" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] block mb-0.5">
                        Virksomhedsoplysninger
                      </span>
                      <p className="text-xs text-[#4A5D50]">
                        CVR: <span className="contact-no-break font-mono font-bold text-[#285F41]">41795638</span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>

              {/* Local Area Callout */}
              <div className="bg-[#285F41] text-white p-6 rounded-2xl space-y-3">
                <div className="flex items-center gap-2 text-emerald-300 font-bold text-xs uppercase tracking-wider">
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                  <span>Lokal betjening i Skjern</span>
                </div>
                <p className="text-xs text-[#C2D6CA] leading-relaxed">
                  Jeg kører ud til privat- og erhvervskunder i Skjern og omegn. Kontakt mig gerne for at høre om muligheden på din adresse.
                </p>
              </div>

            </div>

            {/* Webform Column */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

          </div>
        </div>
      </section>

    </div>
  )
}
